import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getUser } from '../../api/smart-life'
import {useAppSelector} from "../../hooks/redux";

type InitialStateT = { user: any; navigate: any[] }

// const userInitial = {
//   auth: false,
//   firstName: '',
//   secondName: '',
//   email: '',
//   id: 0,
//   img: '',
// }

const initialState: InitialStateT = {
  user: JSON.parse(localStorage.getItem('user') || 'null'),
  // user: userInitial,
  navigate: [],
}

export const loginUserThunk = createAsyncThunk(
  'user/loginUser',
  async (
    { login, password }: { login: string; password: string },
    thunkAPI
  ) => {
    try {
      const response = await getUser({ login, password })
      return response
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.message)
    }
  }
)

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      const userData = action.payload
      localStorage.setItem('user', JSON.stringify(userData))
      state.user = userData
      return state
    },
    setAuth: (state) => {
      // localStorage.setItem('user', JSON.stringify(state.user))
      state.user.auth = !state.user.auth
      return state
    },
    clearUser: (state) => {
      localStorage.removeItem('user')
      state.user = null
      return state
    },
    setNavigate: (state, action) => {
      state.navigate = action.payload
      return state
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loginUserThunk.fulfilled, (state, action) => {
      console.log('adfasdfasfdasfasdfasdfasdf4444444444')
      const newUser: any = action.payload
      state.user = { ...newUser, auth: true }
      // localStorage.setItem('user', JSON.stringify(state.user))
      return state
    })
  },
})

export const { setUser, clearUser, setNavigate, setAuth } = userSlice.actions

export default userSlice.reducer
